import { ICopyable } from '../controls/common/icopyable';

export class ChannelProcess implements ICopyable<ChannelProcess> {
    public id: number = null;
    public receivingChannelId: number = null;
    public processDefinitionId: number = null;
    public issuer: string = null;
    public documentTypeId: number = null;
    public customerId: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): ChannelProcess {
        const instance = new ChannelProcess();
        instance.id = this.id;
        instance.receivingChannelId = this.receivingChannelId;
        instance.processDefinitionId = this.processDefinitionId;
        instance.issuer = this.issuer;
        instance.documentTypeId = this.documentTypeId;
        instance.customerId = this.customerId;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.receivingChannelId = other.receivingChannelId;
        this.processDefinitionId = other.processDefinitionId;
        this.issuer = other.issuer;
        this.documentTypeId = other.documentTypeId;
        this.customerId = other.customerId;
    }
}
